import Link from "next/link";
import { useTranslation } from "react-i18next";
import AccountSection from "@components/account/AccountSection";
import SignupForm from "@components/account/SignupForm";

// import { ErrorAlert } from "@components/common";

export default function SignUp() {
  const { t } = useTranslation();

  return (
    <AccountSection
      title={t("account.signUp.title") as string}
      subTitle={
        <>
          {t("account.signUp.subtitle")}
          <Link
            href="/account/signin"
            className="font-medium text-primary hover:text-primary"
            id="signin-link"
          >
            {t("account.actions.signIn")}
          </Link>
        </>
      }
    >
      <SignupForm />
      {/* <div className="mt-4 sm:mx-auto sm:w-full sm:max-w-md"> */}
      {/* <ErrorAlert title={t("account.signUp.disable") as string} /> */}
      {/* </div> */}
    </AccountSection>
  );
}
